import module from 'app/module.js'
import template from './template.html'

const scorePassword = (pass) => {
  let score = 0
  if (!pass) return score

  let letters = {}
  for (let i = 0; i < pass.length; i++) {
    letters[pass[i]] = (letters[pass[i]] || 0) + 1
    score += 5.0 / letters[pass[i]]
  }

  let variations = {
    digits: /\d/.test(pass),
    lower: /[a-z]/.test(pass),
    upper: /[A-Z]/.test(pass),
    nonWords: /\W/.test(pass),
  }

  let variationCount = Object.values(variations)
    .reduce((variations, check) => variations + (check ? 1 : 0), 0)

  score += (variationCount - 1) * 10

  return Math.floor(score < 100 ? score : 100)
}

class AppSesionActivateComponent {
  success = false
  processing = false
  token = {username: '', password: ''}
  credential = {
    active: false,
    username: '',
    password: '',
    new_password: null,
    new_password_confirm: null,
  }
  passwordValidadores = {
    strength: (value) => this.$passStrength(value),
  }
  passwordConfirmarValidadores = {
    passmatch: (value) => this.$passMatch(value),
  }

  constructor ($urlRouter, $session, $state, $notify, $dialog) {
    this.$urlRouter = $urlRouter
    this.$session = $session
    this.$state = $state
    this.$notify = $notify
    this.$dialog = $dialog
  }

  $onInit () {
    this.credential.username = this.token.username
    this.credential.password = this.token.password
  }

  $passMatch (value) {
    return this.credential.new_password === value
  }

  $passIsSame (value) {
    return this.credential.password !== value
  }

  $passStrength (value) {
    const score = scorePassword(value)
    this.password_strength = score
    this.meter_color = score < 25 ? '' : score < 50 ? 'weak' : score < 75 ? 'good' : 'strong'
    return score >= 50
  }

  $passHelp () {
    this.$dialog.show('app.sesion.pass_help')
  }

  $updatePassword () {
    if (this.processing) return

    this.processing = true

    this.$session.$updatePassword(this.credential.username, this.credential.password, this.credential.new_password)
      .then(() => (this.success = true))
      .catch((error) => {
        if (error === 'PASS_UPDATE_SAME_PASSWORD') {
          this.$notify.error('Old and new passwords are identical')
        } else if (error === 'USER_IS_ACTIVE') {
          this.$notify.error('This account has already been activated')
        } else if (error === 'AUTH_ERROR') {
          this.$notify.error('Wrong password or username')
          this.$state.go('session.auth', {username: this.credential.username}, {location: false})
        }
      })
      .finally(() => (this.processing = false))
  }

  $reload () {
    this.$urlRouter.sync()
  }

  terminosServicio () {
    this.$dialog.show('guest.about.termsOfService')
  }
}

module.component('appSesionActivate', {
  controller: AppSesionActivateComponent,
  template,
  bindings: {
    token: '<',
  },
})



// WEBPACK FOOTER //
// ./src/app/components/sesion/activate/component.js